import apiClient from '../index';

export const invitationApi = {
    // GET /api/guests/invitation — Invitation list
    getInvitationList: (params = {}) => apiClient.get('/guests/invitation', { params }),

    // POST /api/guests/search-by-card — Search invitation by card number
    searchByCard: (cardNumber) => apiClient.post('/guests/search-by-card', { card_number: cardNumber }),

    // GET /api/guests/invited — List invited guests
    getInvitedGuests: (params = {}) => apiClient.get('/guests/invited', { params }),

    // GET /api/guests/attendance — Attendance list
    getAttendanceList: (params = {}) => apiClient.get('/guests/attendance', { params }),

    // POST /api/guests/mark-attendance — Mark attendance
    markAttendance: (data) => apiClient.post('/guests/mark-attendance', data),

    // GET /api/guests/thank-note — Thank-note list
    getThankNoteList: (params = {}) => apiClient.get('/guests/thank-note', { params }),

    // GET /api/export/invitations/{type} — Export invitations as a downloadable file
    exportInvitations: async (type = 'pdf', filename = 'invitations') => {
        const response = await apiClient.get(`/export/invitations/${type}`, {
            responseType: 'blob',
        });
        const blob = response instanceof Blob ? response : new Blob([response]);
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${filename}.${type}`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
    },
};

export default invitationApi;
